  document.addEventListener('DOMContentLoaded', function () {
    const tabTitles = document.querySelectorAll('.tab-title');
    const tabContents = document.querySelectorAll('.tab-content');

    function activateTab(tab) {
      // Remove active class from all tabs
      tabTitles.forEach((item) => item.classList.remove('active'));
      // Add active class to the selected tab
      tab.classList.add('active');

      // Hide all tab contents
      tabContents.forEach((content) => content.classList.remove('active'));
      // Show the selected tab’s content
      document.getElementById(tab.dataset.tab).classList.add('active');
    }

    tabTitles.forEach(function (tab) {
      // Mouse click
      tab.addEventListener('click', function () {
        activateTab(tab);
      });

      // Keyboard (Enter or Space)
      tab.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ' || e.code === 'Space') {
          e.preventDefault(); // prevents spacebar from scrolling
          activateTab(tab);
        }
      });
    });
  });